import * as React from 'react';
import {Pages} from '../../pages';
import {navigateTo} from '../../router';
import {Container} from '../grid/container';
import './style.scss';
import {Translation} from '../../lang';

const logo: string = '/assets/src/components/home/logo.svg';

export class HomeComponent extends React.Component<any, any> {
    private redirectTimeout;

    componentDidMount() {
        this.redirectTimeout = setTimeout(() => {
            navigateTo(Pages.home.navigateTo)
        }, 5000);
    }

    componentWillUnmount() {
        clearTimeout(this.redirectTimeout);
    }

    render() {
        return <Container className="homeComponent">

            <div className="container">
                <div className="col-12 d-flex align-items-center justify-content-center flex-column">
                    <div
                        className="col-10 col-sm-8 col-md-6 col-lg-5 content-height animated fadeInDown mb-4 home-logo">
                        <img src={logo} alt=""/>
                    </div>
                    <div
                        className="d-none d-sm-block d-md-block d-lg-block d-xl-block col-sm-8-xol-lg-5 content-height text-center animated fadeInUp introText">
                        <h3 className="MS text-white text-uppercase typewriter">{Translation.get('home.logoTitle')}</h3>
                    </div>
                    <br/>
                </div>
            </div>

        </Container>;
    }
}
